// Development-only error logging; silent in production builds.
export const logError = (context, err) => {
  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.error(`[${context}]`, err);
  }
};
